import { Link } from 'react-router-dom';
import type { Manga } from '@/mocks/manga';

interface MangaCardProps {
  manga: Manga;
  size?: 'normal' | 'large';
}

export default function MangaCard({ manga, size = 'normal' }: MangaCardProps) {
  const isLarge = size === 'large';

  return (
    <Link
      to={`/manga/${manga.id}`}
      className="group block"
      data-product-shop
    >
      <div className={`relative overflow-hidden rounded-lg bg-background-100 transition-all duration-300 group-hover:scale-[1.02] ${
        isLarge ? 'aspect-[3/4]' : 'aspect-[2/3]'
      }`}>
        <img
          src={manga.cover}
          alt={`${manga.title} - 咻咻漫画全集漫画`}
          title={`${manga.title} | 咻咻漫画`}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
        <div className="absolute top-2 right-2">
          <span className={`px-2 py-0.5 rounded-full text-[10px] font-medium whitespace-nowrap ${
            manga.status === 'completed'
              ? 'bg-accent-500 text-background-50'
              : 'bg-secondary-500 text-background-50'
          }`}>
            {manga.status === 'completed' ? '已完结' : '连载中'}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <h3 className="text-sm font-medium text-white truncate">{manga.title}</h3>
          <div className="flex items-center gap-2 mt-1 text-xs text-white/70">
            <span className="flex items-center gap-0.5">
              <i className="ri-star-fill text-yellow-400 text-[10px]"></i>
              {manga.rating}
            </span>
            <span>{manga.totalChapters}话</span>
          </div>
        </div>
      </div>
    </Link>
  );
}